import type { RouteRecordRaw } from 'vue-router';

export const subServiceRoutes: Array<RouteRecordRaw> = [
  {
    path: '/subscription',
    name: 'subscription',
    redirect: '/subscription/account',
    component: () => import('pages/micros/subscription/McSubscription.vue'),
    meta: {
      title: 'Subscription Service',
      requiresAuth: true,
    },
    children: [
      {
        path: 'pricing',
        name: 'subServicePricing',
        component: () => import('pages/micros/subscription/SubServicePricing.vue'),
        meta: {
          title: 'Subscription Services Pricing',
          requiresAuth: true,
          pageGroup: 'subscriber',
        },
      },
      {
        path: 'app',
        name: 'subApp',
        redirect: '/subscription/app/list',
        component: () => import('pages/micros/subscription/app/SubApplication.vue'),
        meta: {
          title: 'Subscription Application',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'subAppList',
            component: () => import('pages/micros/subscription/app/SubApplicationList.vue'),
            meta: {
              title: 'Subscription Applications List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'subAppDetail',
            component: () => import('pages/micros/subscription/app/SubApplicationDetail.vue'),
            meta: {
              title: 'Subscription Application Detail',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'subAppNew',
            component: () => import('pages/micros/subscription/app/SubApplicationNew.vue'),
            meta: {
              title: 'New Subscription Application',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'app/service',
        name: 'subAppService',
        component: () => import('pages/micros/subscription/appservice/AppServiceList.vue'),
        meta: {
          title: 'Subscription Application-Services',
          requiresAuth: true,
        },
      },
      {
        path: 'get/sub/service',
        name: 'getSubService',
        component: () => import('pages/micros/subscription/GetSubService.vue'),
        meta: {
          title: 'Get Subscription Service [TBD]',
          requiresAuth: true,
        },
      },
      {
        path: 'cancel/service',
        name: 'cancelSubService',
        component: () => import('pages/micros/subscription/CancelSubService.vue'),
        meta: {
          title: 'Cancel Subscription Service',
          requiresAuth: true,
        },
      },
      {
        path: 'pay/order/service/:orderId?',
        name: 'orderSubService',
        component: () => import('pages/micros/subscription/OrderSubService.vue'),
        meta: {
          title: 'Pay and Order Subscription Service',
          requiresAuth: true,
        },
      },
      {
        path: 'app/service/usage',
        name: 'appServiceUsage',
        component: () => import('pages/micros/subscription/AppServiceUsage.vue'),
        meta: {
          title: 'Subscription Application-Service-Usage',
          requiresAuth: true,
        },
      },
      {
        path: 'account',
        name: 'subServiceAccount',
        component: () => import('pages/micros/subscription/SubServiceAccount.vue'),
        meta: {
          title: 'Subscription Service Account (Dashboard)',
          requiresAuth: true,
        },
      },
      {
        path: 'user/:homePath?/:prodPath?',
        name: 'subUser',
        component: () => import('pages/micros/subscription/SubUser.vue'),
        meta: {
          title: 'Subscription User Registration (by Subscriber)',
          requiresAuth: true,
        },
      },
      {
        path: 'user/app',
        name: 'subUserApp',
        redirect: '/subscription/user/app/list',
        component: () => import('pages/central/user/app/UserApp.vue'),
        meta: {
          title: 'Subscription User-Application Assignment',
          requiresAuth: true,
          pagePath: 'subscription/user/app',
          pageGroup: 'subscriber',
        },
        children: [
          {
            path: 'list',
            name: 'subUserAppList',
            component: () => import('pages/central/user/app/UserAppList.vue'),
            meta: {
              title: 'Subscription User-Application Assignment List',
              requiresAuth: true,
              pagePath: 'subscription/user/app/list',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'subUserAppDetail',
            component: () => import('pages/central/user/app/UserAppDetail.vue'),
            meta: {
              title: 'Subscription User-Application Assignment Detail',
              requiresAuth: true,
              pagePath: 'subscription/user/app/detail',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'new',
            name: 'subUserAppNew',
            component: () => import('pages/central/user/app/UserAppNew.vue'),
            meta: {
              title: 'New Subscription User-Application Assignment',
              requiresAuth: true,
              pagePath: 'subscription/user/app/new',
              pageGroup: 'subscriber',
            },
          },
        ],
      },
      {
        path: 'user/role',
        name: 'subUserRole',
        redirect: '/subscription/user/role/list',
        component: () => import('pages/central/user/role/UserRole.vue'),
        meta: {
          title: 'Subscription User-Role Assignment',
          requiresAuth: true,
          pagePath: 'subscription/user/role',
          pageGroup: 'subscriber',
        },
        children: [
          {
            path: 'list',
            name: 'subUserRoleList',
            component: () => import('pages/central/user/role/UserRoleList.vue'),
            meta: {
              title: 'Subscription User-Role Assignment List',
              requiresAuth: true,
              pagePath: 'subscription/user/role/list',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'subUserRoleDetail',
            component: () => import('pages/central/user/role/UserRoleDetail.vue'),
            meta: {
              title: 'Subscription User-Role Assignment Detail',
              requiresAuth: true,
              pagePath: 'subscription/user/role/detail',
              pageGroup: 'subscriber',
            },
          },
          {
            path: 'new',
            name: 'subUserRoleNew',
            component: () => import('pages/central/user/role/UserRoleNew.vue'),
            meta: {
              title: 'New Subscription User-Role Assignment',
              requiresAuth: true,
              pagePath: 'subscription/user/role/new',
              pageGroup: 'subscriber',
            },
          },
        ],
      },
      {
        path: 'user/app/list',
        name: 'subscriberUserAppList',
        component: () => import('pages/micros/subscription/user/UserAppList.vue'),
        meta: {
          title: 'Subscription User-Application Assignments List',
          requiresAuth: true,
          pagePath: 'subscription/user/app/list',
          pageGroup: 'subscriber',
        },
      },

      {
        path: 'user/app/by/email',
        name: 'subscriberUserAppDetail',
        component: () => import('pages/micros/subscription/user/UserAppDetail.vue'),
        meta: {
          title: 'Subscription User-Application Assignment by user-email or user-name',
          requiresAuth: true,
          pagePath: 'subscription/user/app/by/email',
          pageGroup: 'subscriber',
        },
      },
      {
        path: 'user/app/by/email',
        name: 'subscriberUserAppNew',
        component: () => import('pages/micros/subscription/user/UserAppNew.vue'),
        meta: {
          title: 'Subscription User-Application Assignment by user-email or user-name',
          requiresAuth: true,
          pagePath: 'subscription/user/app/by/email',
          pageGroup: 'subscriber',
        },
      },
      {
        path: 'user/role/by/email',
        name: 'subscriberUserRoleDetail',
        component: () => import('pages/micros/subscription/user/UserRoleDetail.vue'),
        meta: {
          title: 'Subscription User-Role Assignment by user-email or user-name',
          requiresAuth: true,
          pagePath: 'subscription/user/role/by/email',
          pageGroup: 'subscriber',
        },
      },
      {
        path: 'user/role/list',
        name: 'subscriberUserRoleList',
        component: () => import('pages/micros/subscription/user/UserRoleList.vue'),
        meta: {
          title: 'Subscription User-Role Assignment List',
          requiresAuth: true,
          pagePath: 'subscription/user/role/list',
          pageGroup: 'subscriber',
        },
      },
      {
        path: 'user/role/by/email',
        name: 'subscriberUserRoleNew',
        component: () => import('pages/micros/subscription/user/UserRoleNew.vue'),
        meta: {
          title: 'Subscription User-Role Assignment by user-email or user-name',
          requiresAuth: true,
          pagePath: 'subscription/user/role/by/email',
          pageGroup: 'subscriber',
        },
      },
    ],
  },
];
